import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			click: {
				button: 'toggleTab'
			}
		}
    }

    init() {
		this.$medias = this.$('media');

		this.bindResize = this.resize.bind(this);
        window.addEventListener("resize", this.bindResize);

    }

	ready() {
		this.resizeDebounce();

		gsap.delayedCall(6,() => {
			this.resizeDebounce();
		});
		gsap.delayedCall(10,() => {
			this.resizeDebounce();
		});
	}

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		let parentHeight = this.el.getBoundingClientRect().height;

		this.$medias.forEach((media) => {
			let height = media.getBoundingClientRect().height;
			
			if(height < parentHeight) {
				media.style.setProperty(
					"--maxTranslate",
					`${parentHeight - height}px`
				);
				media.classList.remove('is-fixed');
			} else {
				media.classList.add('is-fixed');
			}
		})
	}
}
